import { Box, HStack } from '@chakra-ui/react';

import { RtaFeatureIconButton } from '@components';
import { useFullscreenFeature } from '@features';
import { VersionHistoryControl } from '../version-history-control';

export const ViewModeControls = () => {
	const fullscreenMode = useFullscreenFeature();

	return (
		<Box w={'100%'} h={'100%'} m={'1px'} border={'0px'}>
			<HStack h={'100%'} gap={'5px'}>
				<VersionHistoryControl />
				<RtaFeatureIconButton feature={fullscreenMode} />
			</HStack>
		</Box>
	);
};
